import MigrationListPage from "./MigrationListPage";
export default function MigrationUploadedPage() {
  return <MigrationListPage stage="uploaded_for_migration" title="Uploaded for Migration" />;
}
